(function () {
  if (window.__thermoraBundleOffer6) return;
  window.__thermoraBundleOffer6 = true;

  function fileName(src) {
    if (!src) return '';
    var p = String(src).split('?')[0].split('/');
    return p[p.length - 1].toLowerCase();
  }

  function isPackValue(v) { return String(v).indexOf('2-Pack') > -1; }
  function baseOf(v) { return String(v).replace(/\s*·\s*2-Pack/, '').replace(/\s*2-Pack/, '').trim(); }

  function initBundle(root) {
    if (root.__bundleReady) return;
    root.__bundleReady = true;

    var section = root.closest('.shopify-section') || document;
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-qty]'));
    var errorEl = root.querySelector('[data-error]');
    var giftId = root.dataset.giftId || '';
    var giftPerItem = root.dataset.giftPerItem === 'true';
    var data = { options: [], variants: [] };
    try { data = JSON.parse(root.querySelector('[data-bundle-data]').textContent); } catch (e) {}
    var options = data.options || [];
    var variants = data.variants || [];
    var packOi = -1;
    options.forEach(function (o, i) { if (packOi < 0 && (o.values || []).some(isPackValue)) packOi = i; });
    var choiceOptions = [];
    options.forEach(function (o, i) {
      var count = (o.values || []).filter(function (v) { return !isPackValue(v); }).length;
      if (count > 1) choiceOptions.push(i);
    });
    var hasChoices = choiceOptions.length > 0;
    var discounts = { 1: 0, 2: Number(root.dataset.d2) || 0, 3: Number(root.dataset.d3) || 0 };
    var itemLabel = root.dataset.itemLabel || '#';
    var savePill = root.dataset.savePill || 'Save [amount]';
    var formatter;
    try {
      formatter = new Intl.NumberFormat(root.dataset.locale || undefined, { style: 'currency', currency: root.dataset.currency || 'USD' });
    } catch (e) {
      formatter = { format: function (v) { return '$' + v.toFixed(2); } };
    }
    var defaultTier = Number(root.dataset.defaultTier);
    if (!(defaultTier >= 1 && defaultTier <= 3)) defaultTier = 1;
    var currentVariant = String(root.dataset.variant);
    var selectedTier = defaultTier;
    var busy = false;
    var tierState = {};

    function variantById(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }
    function variantByOptions(values) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < values.length; j++) if (variants[i].options[j] !== values[j]) { ok = false; break; }
        if (ok) return variants[i];
      }
      return null;
    }
    // A 2-Pack variant maps to its single version, so the pickers always start on a single.
    function singleOf(v) {
      if (!v || packOi < 0 || !isPackValue(v.options[packOi])) return v;
      var vals = v.options.slice();
      vals[packOi] = baseOf(vals[packOi]);
      return variantByOptions(vals) || v;
    }
    function packFor(single) {
      if (!single || packOi < 0) return null;
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options;
        if (!isPackValue(o[packOi]) || baseOf(o[packOi]) !== single.options[packOi]) continue;
        var ok = true;
        for (var j = 0; j < o.length; j++) if (j !== packOi && o[j] !== single.options[j]) { ok = false; break; }
        if (ok) return variants[i];
      }
      return null;
    }
    // Two of the same size in the 2-item tier -> use the 2-Pack variant instead.
    function samePack(qty) {
      if (qty !== 2) return null;
      var st = tierState[2];
      if (!st || st.rows.length !== 2) return null;
      var a = st.rows[0].variant, b = st.rows[1].variant;
      if (!a || !b || String(a.id) !== String(b.id)) return null;
      var p = packFor(a);
      return p && p.available ? p : null;
    }
    function setNativeQty(qty) {
      var qs = section.querySelector('product-form-component quantity-selector-component');
      if (qs && typeof qs.setValue === 'function') {
        qs.setValue(String(qty));
        if (typeof qs.updateButtonStates === 'function') qs.updateButtonStates();
      } else {
        var input = section.querySelector('product-form-component input[name="quantity"]');
        if (input) input.value = String(qty);
      }
    }
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }
    function showMediaFor(variant) {
      if (!variant || !variant.media) return;
      var target = fileName(variant.media);
      var gallery = section.querySelector('media-gallery');
      if (!target || !gallery) return;
      var slides = gallery.querySelectorAll('slideshow-slide');
      for (var i = 0; i < slides.length; i++) {
        var img = slides[i].querySelector('img');
        if (!img) continue;
        if (fileName(img.currentSrc || img.getAttribute('src')) === target) {
          var s = gallery.slideshow || gallery.querySelector('slideshow-component');
          if (s && typeof s.select === 'function') { try { s.select(i); } catch (e) {} }
          return;
        }
      }
    }
    function updateRow(row) {
      var v = variantByOptions(row.values);
      row.variant = v;
      if (row.soldout) row.soldout.hidden = !!(v && v.available);
    }
    function buildItems(tier) {
      var qty = Number(tier.dataset.qty);
      var container = tier.querySelector('[data-items]');
      if (!container || !hasChoices) return;
      var base = singleOf(variantById(currentVariant) || variants[0]);
      var state = { rows: [] };
      container.innerHTML = '';
      for (var n = 0; n < qty; n++) {
        var el = document.createElement('div');
        el.className = 'bundle-offer__item' + (qty === 1 ? ' bundle-offer__item--single' : '');
        if (qty > 1) {
          var label = document.createElement('span');
          label.className = 'bundle-offer__item-label';
          label.textContent = itemLabel + (n + 1);
          el.appendChild(label);
        }
        let row = { values: base ? base.options.slice() : [], touched: false, selects: [], soldout: null };
        choiceOptions.forEach(function (oi) {
          var option = options[oi];
          var select = document.createElement('select');
          select.className = 'bundle-offer__select';
          select.setAttribute('aria-label', qty > 1 ? option.name + ' ' + itemLabel + (n + 1) : option.name);
          option.values.forEach(function (value) {
            if (isPackValue(value)) return;
            var opt = document.createElement('option');
            opt.value = value;
            opt.textContent = value;
            select.appendChild(opt);
          });
          select.value = row.values[oi];
          select.addEventListener('change', function () {
            row.values[oi] = select.value;
            row.touched = true;
            updateRow(row);
            renderPrices();
            showMediaFor(row.variant);
          });
          row.selects.push({ select: select, index: oi });
          el.appendChild(select);
        });
        var soldout = document.createElement('span');
        soldout.className = 'bundle-offer__soldout';
        soldout.hidden = true;
        soldout.textContent = root.dataset.soldoutText || 'Sold out';
        el.appendChild(soldout);
        row.soldout = soldout;
        container.appendChild(el);
        state.rows.push(row);
        updateRow(row);
      }
      tierState[qty] = state;
    }
    function syncUntouchedRows() {
      var base = singleOf(variantById(currentVariant));
      if (!base) return;
      Object.keys(tierState).forEach(function (k) {
        tierState[k].rows.forEach(function (row) {
          if (row.touched) return;
          row.values = base.options.slice();
          row.selects.forEach(function (s) { s.select.value = row.values[s.index]; });
          updateRow(row);
        });
      });
    }
    function tierPrices(qty) {
      var full = 0;
      var state = tierState[qty];
      if (state && state.rows.length) {
        state.rows.forEach(function (row) {
          var v = row.variant || singleOf(variantById(currentVariant));
          full += v ? Number(v.price) : 0;
        });
      } else {
        var base = singleOf(variantById(currentVariant));
        full = base ? Number(base.price) * qty : 0;
      }
      var pack = samePack(qty);
      if (pack) return { full: full, total: Number(pack.price) };
      return { full: full, total: Math.round((full * (100 - discounts[qty])) / 100) };
    }
    function renderPrices() {
      tiers.forEach(function (tier) {
        var qty = Number(tier.dataset.qty);
        var p = tierPrices(qty);
        if (!p.full) return;
        var t = tier.querySelector('[data-total]');
        var c = tier.querySelector('[data-compare]');
        var s = tier.querySelector('[data-save]');
        if (t) t.textContent = formatter.format(p.total / 100);
        if (c) c.textContent = formatter.format(p.full / 100);
        if (s) s.textContent = savePill.replace('[amount]', formatter.format((p.full - p.total) / 100));
      });
    }
    function selectTier(qty) {
      selectedTier = qty;
      tiers.forEach(function (tier) {
        var on = Number(tier.dataset.qty) === qty;
        tier.classList.toggle('is-selected', on);
        tier.setAttribute('aria-checked', on ? 'true' : 'false');
        var items = tier.querySelector('[data-items]');
        if (items) items.hidden = !(on && hasChoices);
      });
      setNativeQty(qty);
      showError('');
    }
    function setCurrent(id) {
      if (!id || String(id) === currentVariant || !variantById(id)) return;
      currentVariant = String(id);
      syncUntouchedRows();
      renderPrices();
    }

    tiers.forEach(function (tier) {
      buildItems(tier);
      tier.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        selectTier(Number(tier.dataset.qty));
      });
      tier.addEventListener('keydown', function (e) {
        if (e.target !== tier) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectTier(Number(tier.dataset.qty)); }
      });
    });

    document.addEventListener('thermora:variant', function (e) {
      if (root.isConnected && e.detail) setCurrent(e.detail.id);
    });

    window.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.closest || !form.closest('product-form-component')) return;
      if (!root.isConnected || !section.contains(form)) return;
      var addonIds = [];
      Array.prototype.forEach.call(section.querySelectorAll('[data-addon-input]'), function (input) {
        if (input.checked && input.dataset.addonId) addonIds.push(input.dataset.addonId);
      });
      var useRows = hasChoices && tierState[selectedTier];
      if (!addonIds.length && !giftId && !useRows) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      if (busy) return;

      var counts = {};
      var order = [];
      function addItem(id, qty) {
        var key = String(id);
        if (!counts[key]) { counts[key] = 0; order.push(key); }
        counts[key] += qty;
      }
      if (useRows) {
        var pack = samePack(selectedTier);
        if (pack) {
          addItem(pack.id, 1);
        } else {
          var rows = tierState[selectedTier].rows;
          for (var i = 0; i < rows.length; i++) {
            var v = rows[i].variant;
            if (!v || !v.available) { showError(root.dataset.soldoutText || 'Sold out'); return; }
            addItem(v.id, 1);
          }
        }
      } else {
        var idInput = section.querySelector('product-form-component input[name="id"]');
        var mainId = (idInput && idInput.value) || currentVariant;
        if (!mainId) return;
        addItem(mainId, selectedTier);
      }
      addonIds.forEach(function (id) { addItem(id, 1); });
      if (giftId) addItem(giftId, giftPerItem ? selectedTier : 1);

      busy = true;
      showError('');
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: order.map(function (id) { return { id: Number(id), quantity: counts[id] }; }) })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) {
            busy = false;
            showError((res.body && (res.body.description || res.body.message)) || root.dataset.errorText);
            return;
          }
          window.location.href = root.dataset.cartUrl || '/cart';
        })
        .catch(function () { busy = false; showError(root.dataset.errorText); });
    }, true);

    var timer = setInterval(function () {
      if (!root.isConnected) { clearInterval(timer); return; }
      var idInput = section.querySelector('product-form-component input[name="id"]');
      if (idInput && idInput.value) setCurrent(idInput.value);
    }, 400);

    renderPrices();
    selectTier(defaultTier);
    window.setTimeout(function () { setNativeQty(selectedTier); }, 600);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-bundle-offer]');
    for (var i = 0; i < roots.length; i++) initBundle(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  setInterval(boot, 1000);
})();
